import { AxiosResponse } from 'axios'

import { getCerebroHeaders } from 'api/Cerebro/headers'
import { orgScopedApiClient } from 'api/orgScopedClient'

import { CerebroPaginatedResponse } from '../types'

export const getCustomEvents = (
    params: any,
    options: any = {}
): Promise<CerebroPaginatedResponse<unknown>> =>
    orgScopedApiClient.get('/api/custom_events/', {
        params,
        headers: getCerebroHeaders(options.headers),
    })

export const createCustomEvent = (
    data: Record<string, unknown>
): Promise<AxiosResponse<unknown>> =>
    orgScopedApiClient.post('/api/custom_events/', data)

export const updateCustomEvent = (
    id: string | number,
    data: Record<string, unknown>
): Promise<AxiosResponse<unknown>> =>
    orgScopedApiClient.patch(`/api/custom_event/${id}/`, data)

export const deleteCustomEvent = (
    id: string | number
): Promise<AxiosResponse<unknown>> =>
    orgScopedApiClient.delete(`/api/custom_event/${id}/`)

export const getCustomEventsExport = (
    params: Record<string, unknown>,
    options: any = {}
): Promise<AxiosResponse<unknown>> =>
    orgScopedApiClient.get('/api/custom_events/export/async/', {
        params,
        headers: getCerebroHeaders(options.headers),
    })
